/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewSpidersEventItem } from './CRSFSecReviewSpidersEventItem';
import {
    CRSFSecReviewSpidersEventItemFromJSON,
    CRSFSecReviewSpidersEventItemFromJSONTyped,
    CRSFSecReviewSpidersEventItemToJSON,
} from './CRSFSecReviewSpidersEventItem';

/**
 * 
 * @export
 * @interface CRSFSecReviewSpidersPagedResponse
 */
export interface CRSFSecReviewSpidersPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSpidersPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSpidersPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewSpidersEventItem>}
     * @memberof CRSFSecReviewSpidersPagedResponse
     */
    results?: Array<CRSFSecReviewSpidersEventItem>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewSpidersPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewSpidersPagedResponse interface.
 */
export function instanceOfCRSFSecReviewSpidersPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewSpidersPagedResponseFromJSON(json: any): CRSFSecReviewSpidersPagedResponse {
    return CRSFSecReviewSpidersPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewSpidersPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewSpidersPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewSpidersEventItemFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewSpidersPagedResponseToJSON(value?: CRSFSecReviewSpidersPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewSpidersEventItemToJSON)),
        'total': value.total,
    };
}

